module.exports = __webpack_public_path__ + "static/media/woopay-wallet.29102b86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/woopay-wallet.svg
// module id = 890
// module chunks = 7